var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3538 5.95833C13.7085 5.95833 12.3747 4.62451 12.3747 2.97917C12.3747 1.33382 13.7085 0 15.3538 0C16.9992 0 18.333 1.33382 18.333 2.97917C18.333 4.62451 16.9992 5.95833 15.3538 5.95833Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 18.3334C14.0642 18.3334 12.833 17.1022 12.833 15.5834C12.833 14.0646 14.0642 12.8334 15.583 12.8334C17.1018 12.8334 18.333 14.0646 18.333 15.5834C18.333 17.1022 17.1018 18.3334 15.583 18.3334Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 8.33337C1.23122 8.33337 9.53674e-07 7.10216 9.53674e-07 5.58337C9.53674e-07 4.06459 1.23122 2.83337 2.75 2.83337C4.26878 2.83337 5.5 4.06459 5.5 5.58337C5.5 7.10216 4.26878 8.33337 2.75 8.33337Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59384 6.65505C3.48301 9.20339 5.88467 10.9176 8.58884 10.9176C8.59801 10.9176 8.60717 10.9176 8.61634 10.9176L11.8522 10.9084C13.2455 10.8901 14.4922 11.8342 14.868 13.1909V14.8776C14.868 15.2626 15.1797 15.5742 15.5738 15.5742C15.968 15.5742 16.2705 15.2626 16.2705 14.8776V4.59255C16.2705 4.20755 15.9588 3.89589 15.5738 3.89589C15.1888 3.89589 14.868 4.20755 14.868 4.59255V10.6609C14.0613 9.94589 13.0072 9.50589 11.8613 9.50589C11.8522 9.50589 11.8522 9.50589 11.843 9.50589L8.60717 9.51505C8.59801 9.51505 8.59801 9.51505 8.58884 9.51505C6.48967 9.51505 4.61051 8.18589 3.92301 6.19672C3.81301 5.90339 3.54717 5.72005 3.25384 5.72005C3.18051 5.72005 3.09801 5.72922 3.02467 5.75672C2.65801 5.88505 2.46551 6.28839 2.59384 6.65505Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney);
export default __webpack_public_path__ + "static/media/journey.f8477f7d60eee5c7a48d0a78147ff048.svg";
export { ForwardRef as ReactComponent };